<script setup lang="ts">
import { GpAvatar } from '@gportal/uikit';
import { useAvatarStore } from 'gpcore-apikit/store/pinia/avatar';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import { computed } from 'vue';

// in case the avatar has change during runtime, we need to access the store directly
const avatarStore = useAvatarStore();
const projectStore = useProjectStore();
const project = computed(() => projectStore.project);
const avatarKey = computed(() => {
  if (project.value != null) {
    const avatarId = Object.keys(avatarStore.avatars).find((key) => key === project.value.id);

    if (avatarId == null) {
      return null;
    }

    // return the client side timestamp of the avatar, which only is set by uploading a new avatar
    return avatarStore.avatars[avatarId];
  }

  return 'default';
});
</script>

<template>
  <GpAvatar
    :src="project.avatarUrl"
    :alt="project.name"
    custom-size
    :key="avatarKey"
    style="--gp-avatar-size: 84px"
  />
</template>

<style scoped></style>
